import React from "react";
import './Contact.css'


const Contact=()=>{
    return(
    <div className="contact-div">
          <div className="contact-head-box">
            <h1>Contact Us</h1>
            <p>Swing by for a cup of coffee, or leave us a message:</p>
          </div>
          <div className="contact-down-box">
          <img className="contact-img" src="https://www.linkpicture.com/q/tabl_cartoon_1.jpg" alt="contact-img"/>
        
        <form id="change" className="contact-form">
          <div className="each">
          <label htmlFor="first">First Name</label>
          <input className="text" type="text" id="first"/>
          </div>
          <div className="each">
          <label htmlFor="second">Last Name Name</label>
          <input  className="text" type="text" id="second"/>
          </div>
          <div className="each">
          <label htmlFor="address">Address</label>
          <input className="text" type="text" id="address"/>
          </div>
          <div className="each">
          <label htmlFor="first">Comment</label>
          <textarea className="text-area" rows={15} columns={40} id="first" placeholder="Put your thoughts here"/>
          </div>
          <div className="button-div">
            <button type="submit" className="buttons">Submit</button>
          </div>
        </form></div>        
        
    </div>)
}
export default Contact